var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.00088C21.5304 8.00088 22.0391 8.21159 22.4142 8.58666C22.7893 8.96174 23 9.47044 23 10.0009V14.0009C23 14.5313 22.7893 15.04 22.4142 15.4151C22.0391 15.7902 21.5304 16.0009 21 16.0009H19.938C19.6942 17.9342 18.7533 19.7121 17.2917 21.0009C15.8302 22.2897 13.9486 23.0008 12 23.0009V21.0009C13.5913 21.0009 15.1174 20.3687 16.2426 19.2435C17.3679 18.1183 18 16.5922 18 15.0009V9.00088C18 7.40958 17.3679 5.88345 16.2426 4.75824C15.1174 3.63302 13.5913 3.00088 12 3.00088C10.4087 3.00088 8.88258 3.63302 7.75736 4.75824C6.63214 5.88345 6 7.40958 6 9.00088V16.0009H3C2.46957 16.0009 1.96086 15.7902 1.58579 15.4151C1.21071 15.04 1 14.5313 1 14.0009V10.0009C1 9.47044 1.21071 8.96174 1.58579 8.58666C1.96086 8.21159 2.46957 8.00088 3 8.00088H4.062C4.30603 6.06777 5.24708 4.29015 6.70857 3.00155C8.17007 1.71296 10.0516 1.00195 12 1.00195C13.9484 1.00195 15.8299 1.71296 17.2914 3.00155C18.7529 4.29015 19.694 6.06777 19.938 8.00088H21ZM7.76 15.7859L8.82 14.0899C9.77308 14.6869 10.8754 15.0027 12 15.0009C13.1246 15.0027 14.2269 14.6869 15.18 14.0899L16.24 15.7859C14.9693 16.582 13.4995 17.0032 12 17.0009C10.5005 17.0032 9.03074 16.582 7.76 15.7859Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCare);
export default __webpack_public_path__ + "static/media/customer-care.72fd6a82a3e0fc8d104d542f26b5bbfa.svg";
export { ForwardRef as ReactComponent };